import { createSlice } from "@reduxjs/toolkit";
import { PostCustomerSearch } from "./CustomerListingAction";
import { customerDetailsCardData } from "../../constants/CustomerDetailsCardData";
import {clearCustomerSearchData} from "./CustomerListingAction"

export interface AddressProps {
  addr1: string;
  addrTypeCd: string;
  city: string;
  county: string;
  postalCode: string;
  regionCd: string;
  regionISOCd: string;
  stateProvCd: string;
}
export interface ISearchItem {
  carrier: string;
  customerId: string;
  customerName: string;
  entityType: string;
  system: string;
  address: AddressProps;
}

interface ICustomerSearchListSlice {
  searchList: ISearchItem[];
  morethanTen: boolean;
}
interface CustomerDetails {
  customerId: string;
  customerName: string;
}

interface ISearchListSlice {
  customerSerachData: ICustomerSearchListSlice | null;
  customerDetails: CustomerDetails | null;
}
const initialState: ISearchListSlice = {
  customerSerachData: null,
  customerDetails: null,
};
const customerSearchSlice = createSlice({
  name: "customerSearch",
  initialState: initialState,
  reducers: {
    setcustomerDetails: (state, { payload }) => {
      state.customerDetails = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PostCustomerSearch.fulfilled, (state, { payload }) => {
      state.customerSerachData = payload.data;
    });
    builder.addCase(clearCustomerSearchData, (state) => {
      state.customerSerachData = null;
    });
  },
});

export default customerSearchSlice.reducer;
export const { setcustomerDetails } = customerSearchSlice.actions;
